module.exports = __webpack_public_path__ + "img/kissing-face-with-closed-eyes.3e0ce365.png";